import type { SigningPersonId } from '../types/wizard.types';

export const SIGNING_PERSON_OPTIONS: Array<{ value: SigningPersonId; label: string }> = [
  { value: 'lapaev', label: 'Лапаев Александр Юрьевич' },
  { value: 'vasyutin', label: 'Васютин Роман Николаевич' },
  { value: 'koreshin', label: 'Корешин Евгений Александрович' },
  { value: 'office', label: 'ОФИС (Коновалова / Федина)' },
];

export function signingPersonLabel(id: SigningPersonId): string {
  return SIGNING_PERSON_OPTIONS.find((o) => o.value === id)?.label ?? id;
}
